
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.985,"time":59100,"words":197}
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "références"
    }}>{`Références`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`J Scott Brennen. An industry-led debate: How uk media cover artificial intelligence. 2018.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Dominique Cardon, Maxime Crépel, Renuka George. Algorithms and Territorial Regulation. Gouverner la ville numérique, Collège de France; Presses Universitaires de France, 2019, 9782130815259`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Francis Chateauraynaud. Regard analytique sur l’activité visionnaire. Du risque à la menace. Penser la catastrophe, Paris, PUF, pages 309–389, 2013.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Francis Chateauraynaud and Josquin Debaz. Agir avant et après la fin du monde, dans l’infinité des milieux en interaction. Multitudes, (3):126–132, 2019.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Anna Jobin, Marcello Ienca, and Effy Vayena. The global landscape of ai ethics guidelines. Nature Machine Intelligence, 1(9):389–399, 2019. `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Brent Mittelstadt. Principles alone cannot guarantee ethical ai. Nature Machine Intelligence, 1(11):501–507, 2019. `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Raymond Perrault, Yoav Shoham, Erik Brynjolfsson, Jack Clark, John Etchemendy, Barbara Grosz, Terah Lyons, James Manyika, Saurabh Mishra, and Juan Carlos Niebles. The ai index 2019 annual report. AI Index Steering Committee, Human-Centered AI Institute, Stanford University, Stanford, CA, 2019. `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Nick Seaver. Algorithms as culture: Some tactics for the ethnography of algorithmic systems. Big Data & Society, 4(2):2053951717738104, 2017.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Beth Singler. Existential hope and existential despair in AI apocalypticism and transhumanism, Zygon, 54 (1), 156–176, 2019.`}</p>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  {
    id: "références",
    level: 2,
    title: "Références",
    children: [
        
      ]
  }
]

export const frontMatter = {}

